import Chart from 'chart.js/auto';
window.Chart = Chart;

import $ from 'jquery';
window.$ = $;
window.jQuery = $;

window.AOS = require('aos');
import 'datatables.net';
import 'datatables.net-bs5';
import 'jquery-serializejson';
import 'jquery-confirm';
window.printJS = import('print-js')

window.Popper = require('@popperjs/core').default;
require('bootstrap');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
